import { stringify } from "query-string";

const convertFileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file.rawFile);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

function authHeaders() {
  try {
    const auth = JSON.parse(localStorage.getItem("auth") || "{}");
    return auth.token ? { Authorization: `Bearer ${auth.token}` } : {};
  } catch {
    return {};
  }
}

const dataProvider = {
  getList: async (resource, params) => {
    const { page, perPage } = params.pagination;
    const { field, order } = params.sort;
    const query = {
      filter: JSON.stringify(params.filter),
      sort: JSON.stringify([field, order]),
      range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
    };
    const url = `/admin/${resource}?${stringify(query)}`;

    const response = await fetch(url, { headers: authHeaders() });
    const range = parseInt(
      response.headers.get("content-range").split("/").pop(),
      10,
    );
    const json = await response.json();
    return { data: json, total: range };
  },
  getOne: async (resource, params) => {
    const json = await fetch(`/admin/${resource}/${params.id}`, { headers: authHeaders() });
    const obj = await json.json();
    return { data: obj };
  },
  create: async (resource, params) => {
    try {
      params.data.image = await convertFileToBase64(params.data.image);
    } catch (err) {
      console.log(err);
    }
    const json = await fetch(`/admin/${resource}`, {
      method: "POST",
      headers: { "Content-Type": "application/json", ...authHeaders() },
      body: JSON.stringify(params.data),
    }).then((response) => {
      if (response.status == 429) {
        throw new Error("Product already exists!");
      }
      return response;
    });
    const obj = await json.json();
    return { data: { ...params.data, id: obj.id } };
  },
  update: async (resource, params) => {
    try {
      params.data.image = await convertFileToBase64(params.data.image);
    } catch (err) {
      console.log(err);
    }
    const json = await fetch(`/admin/${resource}/${params.id}`, {
      method: "PUT",
      headers: { "Content-Type": "application/json", ...authHeaders() },
      body: JSON.stringify(params.data),
    });
    const obj = await json.json();
    return { data: obj };
  },
  delete: async (resource, params) => {
    const json = await fetch(`/admin/${resource}/${params.id}`, {
      method: "DELETE",
      headers: { "Content-Type": "application/json", ...authHeaders() },
    });
    const obj = await json.json();
    return { data: obj };
  },
  getMany: async (resource, params) => {
    const query = {
      filter: JSON.stringify({ id: params.ids }),
    };
    const url = `/admin/${resource}?${stringify(query)}`;

    const response = await fetch(url, { headers: authHeaders() });
    const json = await response.json();
    return { data: json };
  },

  // getManyReference: async (resource, params) => {
  //     const { page, perPage } = params.pagination;
  //     const { field, order } = params.sort;
  //     const query = {
  //         sort: JSON.stringify([field, order]),
  //         range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
  //         filter: JSON.stringify({
  //             ...params.filter,
  //             [params.target]: params.id,
  //         }),
  //     };
  //     const url = `admin/${resource}?${stringify(query)}`;

  //     const response = await fetch(url);
  //     const range = parseInt(response.headers.get('content-range').split('/').pop(), 10);
  //     const json = await response.json();
  //     return { data: json, total: range};
  // },
  // updateMany: () => {
  //     return httpClient('http://localhost:8080/admin/').then(({json}) => ({data: json}));
  // },
  // deleteMany: () => {
  //     return httpClient('http://localhost:8080/admin/').then(({json}) => ({data: json}));
  // }
};

export default dataProvider;
